import type {
  PrepaidSettings,
  PrepaidOverrides,
  PrepaidBalance,
  PrepaidAction,
  PrepaidStockOptions,
} from '@hue/contracts';
import { api } from '../../lib/api.js';

export const prepaidApi = {
  settings: async () =>
    (await api.get<{ settings: PrepaidSettings }>('/tenant/prepaid-balances/settings')).data
      .settings,
  saveSettings: async (settings: PrepaidSettings) =>
    (await api.put<{ settings: PrepaidSettings }>('/tenant/prepaid-balances/settings', settings))
      .data.settings,
  rules: async (id: string) =>
    (await api.get<{ rules: PrepaidOverrides }>(`/tenant/prepaid-balances/packages/${id}/rules`))
      .data.rules,
  saveRules: async (id: string, rules: PrepaidOverrides) =>
    (
      await api.put<{ rules: PrepaidOverrides }>(
        `/tenant/prepaid-balances/packages/${id}/rules`,
        rules,
      )
    ).data.rules,
  list: async (
    id: string,
    params: {
      search: string;
      limit: number;
      offset: number;
      referenceId?: string | undefined;
      balanceId?: string | undefined;
      saleId?: string | undefined;
    },
  ) =>
    (
      await api.get<{ balances: PrepaidBalance[]; total: number }>(
        id ? `/tenant/clients/${id}/prepaid-balances` : '/tenant/prepaid-balances/withdrawals',
        { params },
      )
    ).data,
  history: async (id: string, offset: number) =>
    (
      await api.get<{ events: PrepaidBalance['events']; total: number }>(
        `/tenant/prepaid-balances/${id}/history`,
        { params: { limit: 25, offset } },
      )
    ).data,
  stockOptions: async (id: string, locationId: string | undefined, quantity: number) =>
    (
      await api.get<PrepaidStockOptions>(`/tenant/prepaid-balances/${id}/stock-options`, {
        params: { locationId, quantity },
      })
    ).data,
  act: async (id: string, action: PrepaidAction) =>
    (await api.post<{ balance: PrepaidBalance }>(`/tenant/prepaid-balances/${id}/actions`, action))
      .data.balance,
};
